// @core/api/endpoints/booking/reschedule_booking.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingLifecycleResponse,
  RescheduleBookingRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Reschedule booking
 * Moves a confirmed booking to a new time slot. Validates availability per booking policy (min_notice, max_reschedules, reschedule_notice). Notifies both customer and provider.
 */
export async function RescheduleBooking(
  target_type: string,
  target_id: string,
  data: RescheduleBookingRequest,
  options?: RequestOptions
): Promise<BookingLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking/:target_type/:target_id/reschedule`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<BookingLifecycleResponse>(requestPath, data, requestOptions);
}
